// extracted by mini-css-extract-plugin
export default {"price":"F8-z","onSale":"G8-z","msrpLabelPrice":"H8-z","msrpLabel":"I8-z","originalPrice":"J8-z","percentOff":"K8-z"};